import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { COURSE_MODULE_API } from '../api/module-api'
import { ModuleId, QuizInterface } from '../types/module-interface'

export const useModuleApi = () => {
  const { fetcher: postFetcher } = useFetch<RequestMethodsEnum.post, QuizInterface>({
    method: RequestMethodsEnum.post,
  })

  const { fetcher: deleteFetcher } = useFetch<RequestMethodsEnum.delete>({
    method: RequestMethodsEnum.delete,
  })

  return {
    creatingQuizForModule: (id: ModuleId) => postFetcher(`${COURSE_MODULE_API}/${id}/create-quiz`),
    removeModuleWithLectures: (moduleId: ModuleId) =>
      deleteFetcher(`${COURSE_MODULE_API}WithLectures/${moduleId}`),
  }
}
